import { EventBus } from '~/plugins/event-bus';
import {disableLoader, enableLoader} from "@/helpers/loader";

export default {
  async init({ dispatch, state }) {
    if (!state.hasData) {
      dispatch('fetch');
    }
  },

  async onsiteStatusChange({ state, commit }, payload) {

    commit('setWorkerOnsiteStatus', payload)
    
    EventBus.$emit('createSnackbar', {
      message: payload.message,
    });
  },

  async fetch({ commit }, payload) {
    try {
      const response = await this.$axios.get('/api/me/workers', {
        params: { ...payload.query, include_stats: true },
      });
      
      const { data, links, meta } = response.data;

      if (payload.reset) {
        commit('setWorkers', data);
      } else {
        commit('addWorkers', data);
      }

      commit('setLinks', links);
      commit('setMeta', meta);
      commit('toggleData');
      commit('setClear', false);
    } catch (err) {
      commit('setMeta', err);
      console.log(err);
    }
  },

  async fetchAssignments({ commit }, slug) {
    try {
      let response;
      if (typeof slug === 'object') {
        response = await this.$axios.get(
          '/api/me/workers/' + slug.slug + '/assignments',{
            params: {
              sort: slug.sort,
              site_id: slug.site_id,
              include_stats: true,
            }
          }
        );
      } else {
        response = await this.$axios.get(
          '/api/me/workers/' + slug + '/assignments',
          { params: { include_stats: true } }
        );
      }
      commit('setAssignments', response.data.data);
    } catch (err) {
      console.log(err);
    }

  },
  
  async fetchFilters({ commit }, slug = null) {
    try {
      const filters = await this.$axios.get(
        '/api/me/workers/' + slug + '/timesheets/filters'
      );
      commit('setFilters', filters.data);
    } catch (err) {
    }
  },
  async fetchContracts({ commit }, slug) {
    try {
      const response = await this.$axios.get(
        '/api/me/workers/' + slug + '/contracts'
      );
      commit('setContracts', response.data.data);
    } catch (err) {
      console.log(err);
    }

  },

  async fetchAssignable({ commit }, {site_id, date_from, date_to}) {
    try {
      const response = await this.$axios.get(
        '/api/me/workers/simple', {
          params: {
            status: 'ASSIGNABLE',
            site_id: site_id,
            date_from,
            date_to
          }
        }
      );


      return response.data.data;
    } catch (err) {
      console.log(err);
    }
  },

  async link({ commit }, payload) {
    enableLoader()
    try {
      const workers = await this.$axios({
        method: 'post',
        url: '/api/me/workers/link',
        data: payload.formData,
      }).then((res) => {
        // commit('setNewWorker', res.data.data.user);
        this.$router.push('/workers');
      });
      EventBus.$emit('createSnackbar', {
        message: 'Worker linked successfully.',
      });
    } catch (err) {
      EventBus.$emit('createSnackbar', {
        message: 'Error during link workers, check all tabs for errors!',
      });
      commit('setError', err);
    }
    disableLoader()
  },

  async batch({ commit }, formData) {
    enableLoader()
    commit('setError', '');
    commit('setBatchInfo', null);
    try {
      const response = await this.$axios({
        method: 'post',
        url: '/api/me/workers/excel',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      });

      EventBus.$emit('createSnackbar', {
        message: response.data.msg || 'Batch import success',
      });
      commit('setBatchInfo', response);
    } catch (err) {
      commit('setError', err);
      EventBus.$emit('createSnackbar', { message: err.message });
    }
    disableLoader()
  },
  async batchDelete({commit}, formData ) {
    try {
      const response = await this.$axios({
        method: 'post',
        url: '/api/me/workers/excel/delete', 
        data: formData
      });

    } catch (err) {
      EventBus.$emit('createSnackbar', { message: err.message });
    }
  },
  async fetchWorkerCheckins({ commit, state }, payload) {
    try {
      const response = await this.$axios.get(
        `/api/me/workers/${payload.worker_slug}/checkins2`, {
          params: payload.query,
        })
      
      const { data: checkins, meta } = response.data

      commit('setWorkerCheckins', {
        checkins: checkins,
        replace: payload.reset
      })
      commit('setWorkerCheckinsMeta', meta)

    } catch (err) {
      commit('setWorkerCheckinsMeta', err)
      console.log(err)
    }
  },
  async fetchCheckInsExcelDownloadUrl({ commit, state }, payload) {
    try {
      const response = await this.$axios.get(`/api/me/workers/${payload.userSlug}/checkins/excel`,{ params: payload });
      commit('setCheckInExcelUrl', response.data.data.url);
    } catch (err) {
      commit('setError', err);
    }
  },

  async fetchForSummary({ commit }) {
    try {
      const response = await this.$axios.get('/api/me/workers', {
        params: { per_page: 500 }
      })
      commit('setSummaryWorkers', response.data.data)
    } catch (err) {
      // silently fail
    }
  },

  async fetchExpiringCardsCount({ commit }) {
    try {
      const response = await this.$axios.get('/api/me/workers', {
        params: { info: 'cscs_expiring', per_page: 1 }
      })
      commit('setExpiringCardsCount', response.data.meta?.total || 0)
    } catch (err) {
      // silently fail
    }
  },

};
